import PipelineList from "./PipelineList";

export default {
    list: PipelineList,
}
